module.exports = __webpack_public_path__ + "e7bb2a57260f446b7643478ed94470cb.png";